import React, { Component } from "react";
import { Container } from "reactstrap";

//Import Breadcrumb
import Breadcrumbs from "../../../../components/Common/Breadcrumb";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { addContractor } from "../../../../store/contractors/actions";
import ContractorInformationForm from "./components/ContractorInformationForm";
import ModifiedMetaTags from "../../../../components/ModifiedMetaTags";

class AddContractors extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <React.Fragment>
        <div className="page-content">
        <ModifiedMetaTags title="Add contractor | Mobihunter" />

          <Container fluid>
            <Breadcrumbs
              title="Contractors"
              breadcrumbItem="Add contractor"
              link="/contractors"
            />
            <ContractorInformationForm
              contactData={this.props.contactData}
              history={this.props.history}
              addContractor={this.props.addContractor}
              loader={false}
              permissions={this.props.permissions}
            />
          </Container>
        </div>
      </React.Fragment>
    );
  }
}

AddContractors.propTypes = {
  contactData: PropTypes.shape({
    results: PropTypes.arrayOf(PropTypes.object).isRequired,
  }).isRequired,
  history: PropTypes.object.isRequired,
  addContractor: PropTypes.func.isRequired,
  permissions: PropTypes.any,
};

const mapStateToProps = state => ({
  contactData: state.ContractorList.data,
  permissions: state.User.permissions,
});

export default connect(mapStateToProps, {
  addContractor,
})(AddContractors);
